import React from 'react';
import { classNames } from '@hydrogen/elements.ui.utils';
import { themes } from 'theme';

type ContentProps = {
    children?: React.ReactNode | null,
    breadcrumbs?: React.ReactNode | React.ReactNode[] | null,
}

export const Content = ({ children, breadcrumbs }: ContentProps) => (
    <main
        className={classNames(
            themes.main.box,
            themes.main.colors,
            themes.main.font,
        )}
    >
        <div className="mx-auto px-4 sm:px-6 md:px-16 max-w-screen-xl">
            {breadcrumbs}
            {children}
        </div>
    </main>
);
